<section class="cst-tabs p-0">
	<div class="col-md-12">
		<div
			class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-md-10 offset-md-1"
		>
			<!-- Nav pills for category filter -->
			<ul class="nav nav-pills" role="tablist">
				<li
					class="nav-item"
					*ngFor="let category of ['All', 'Branding', 'UX/UI', 'eCommerce']"
				>
					<a
						class="nav-link"
						[class.active]="
							selectedCategory === (category === 'All' ? 'all' : category)
						"
						(click)="getFilterProjects1(category === 'All' ? 'all' : category)"
					>
						{{ category }}
					</a>
				</li>
			</ul>
		</div>
		<div class="tab-content">
			<div id="all" class="tab-pane active">
				<div class="container">
					<div class="row mb-4">
						<div
							class="col-md-4"
							*ngFor="let project of displayedProjects; let i = index"
						>
							<div class="imgblock project-block">
								<ng-container *ngIf="project.link !== '#'">
									<a [href]="project.link" target="_blank">
										<img
											[src]="backendUrl + 'project/' + project.image"
											alt="pixtar's projects"
											class="galleryimg{{ i }}"
											(mouseenter)="onMouseEnter(i)"
											(mouseleave)="onMouseLeave()"
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</ng-container>
								<ng-container *ngIf="project.link === '#'">
									<div class="disabled-link">
										<img
											[src]="backendUrl + 'project/' + project.image"
											alt="Creative Projects by Pixtar"
											class="galleryimg{{ i }}"
											(mouseenter)="onMouseEnter(i)"
											(mouseleave)="onMouseLeave()"
											width=""
											height=""
											loading="lazy"
										/>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
					<div class="row mb-4 mt-3" *ngIf="isMorePrasent">
						<div class="col-md-4">
							<div class="position-absolute start-50 translate-middle">
								<p *ngIf="isactive">
									<a (click)="showMoreProjects()" class="cstbtn cstbtn128 ftr1">
										<span class="text text128"> Load More</span>
										<span class="borderspan"
											><!--<i class="fa fa-chevron-right" aria-hidden="true"></i> -->
											<lucide-icon
												name="chevron-right"
												class="lucide-arrow-icon"
											></lucide-icon>
										</span>
									</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Show More button -->
<!-- <div class="text-center mt-3" *ngIf="showMoreButtonVisible">
	<button class="btn btn-primary" (click)="showMoreProjects()">Show More</button>
</div> -->
